import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css' // ✅ Hanya import index.css
import App from './App.jsx'
import { LanguageProvider } from './i18n/LanguageProvider.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </StrictMode>,
)
